<footer>
  <div class="container">
    <div class="row">
      <div class="ft-col col-12 col-sm-12 col-md-4">
        <div class="logo-footer">
          <a href="https://calauctions.com/auction"> <img
              src="https://calauctions.com/auction/wp-content/uploads/2022/05/logo_white.png"></a>
        </div>
        <p> Cal Auctions &amp; Estate Sales was formed in 2011 to provide online auction services for the commercial
          and
          estate community.

        </p>
      </div>

      <div class="ft-col newsfooter col-12 col-sm-12 col-md-4">



        <h4>Recent News</h4>

        <div class="blog_col_wrap">

          <div class="blog_img">


            <a
              href="https://calauctions.com/auction/how-to-make-money-with-government-surplus-auctions/">
              <img src="https://calauctions.com/auction/wp-content/uploads/2019/03/download.jpg" /></a>

          </div>


          <div class="blog_title">
            <p> <a
                href="https://calauctions.com/auction/how-to-make-money-with-government-surplus-auctions/">How To Make Money With Government Surplus Auctions</a></p>
          </div>
        </div>

        <div class="blog_col_wrap">

          <div class="blog_img">


            <a
              href="https://calauctions.com/auction/the-difference-between-vintage-antique-and-retro/">
              <img src="https://calauctions.com/auction/wp-content/uploads/2022/07/Antique-Vintage-Retro.png" /></a>

          </div>


          <div class="blog_title">
            <p> <a
                href="https://calauctions.com/auction/the-difference-between-vintage-antique-and-retro/">The Difference Between Vintage, Antique, And Retro</a></p>
          </div>
        </div>

        <div class="blog_col_wrap">

          <div class="blog_img">


            <a
              href="https://calauctions.com/auction/read-this-before-you-throw-out-your-junk/">
              <img src="https://calauctions.com/auction/wp-content/uploads/2021/04/flea-market.jpeg" /></a>

          </div>


          <div class="blog_title">
            <p> <a
                href="https://calauctions.com/auction/read-this-before-you-throw-out-your-junk/">Read This Before You Throw Out Your "Junk"</a></p>
          </div>
        </div>



      </div>


      <div class="ft-col socialfooter col-12 col-sm-12 col-md-4">


        <h4>Follow us</h4>
        <div class="social-bt">
          <a target="_blank" href="https://www.facebook.com/CalAuctions/"><img
              src="https://calauctions.com/auction/wp-content/themes/calauction/images/social1.png"></a> <a
            target="_blank" href="https://www.linkedin.com/company/cal-auctions/"><img
              src="https://calauctions.com/auction/wp-content/themes/calauction/images/social2.png"></a> <a
            target="_blank" href="https://www.instagram.com/calauctions"><img
              src="https://calauctions.com/auction/wp-content/uploads/2022/03/insta_w.png"></a> <a
            target="_blank" href="https://twitter.com/calauctions"><img
              src="https://calauctions.com/auction/wp-content/uploads/2022/03/twit.png"></a> <a
            target="_blank" href="https://www.youtube.com/channel/UCAzGo7EuprxumfXzudasaXg"><img
              src="https://calauctions.com/auction/wp-content/uploads/2022/03/yout.png"></a>
        </div>
      </div>
    </div>
  </div>

  <div class="footer_bottom mt-4">
    <div class="container">
      <div class="d_wrap">
        <div class="copyright">
          © Copyright 1999 - 2024 CAL AUCTIONS. All Rights Reserved. </div>
        <div class="addr">
          <a href="https://calauctions.com/auction/privacy-policy/">Privacy Policy</a> <a
            href="https://calauctions.com/auction/terms-conditions/">Terms and Conditions</a>
        </div>
      </div>
    </div>
  </div>
</footer>
